import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse }  from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from "rxjs/operators";

import { LoginService } from './shared/service/login/login.service';

@Injectable()
export class LogoutInterceptor implements HttpInterceptor {

    constructor(private loginService : LoginService) {

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {

                }
            }, (err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 401 || err.status == 403) {
                        //this.router.navigate(['login']);
                        this.loginService.logout();
                    }
                }
            })
        )
    }
}
